import classNames from "classnames";
import { DotsTableView } from "dots-ui/dotsTable";
import React from "react";
import { ResCallback } from "../../../../../models";
import { IModalConditionalResult } from "../../modal";
import {
  IAvisEditableListFieldConfig,
  IEditableListRowState,
  IEditableRowState,
} from "../types";
import { AvisEditableListDescriptionListRow } from "./layoutDescriptionList";
import { AvisEditableListTableRow } from "./layoutTable";

export interface IAvisEditableListRowClassProps<
  P extends IEditableListRowState,
> {
  prefix: string;
  index: number;
  value: P;
  fields: IAvisEditableListFieldConfig<P>[];
  errors: any;
  classNameField?: string;
  disabled?: boolean;
  loading?: boolean;
  arrayLength: number;
  forceUpdateKey?: any;
  hideEdit?: boolean;
  /** Table view. */
  view?: DotsTableView;
  res: ResCallback;
  customEditCallback?: (index: number) => void;
  isDeletable?: (fieldValue: P) => boolean;
  confirmBeforeDelete?: (fieldValue: P) => IModalConditionalResult | undefined;
  onChange: (e: any) => void;
  onStateChange?: (index: number, toState: IEditableRowState) => void;
}

export class AvisEditableListRowClass<
  P extends IEditableListRowState,
> extends React.Component<IAvisEditableListRowClassProps<P>> {
  public render() {
    const rowClass = classNames(
      "avis-editable-list-row",
      this.props.value?.rowState ?? "View",
    );
    if (this.props.view === "description-list")
      return (
        <AvisEditableListDescriptionListRow
          rowClass={rowClass}
          {...this.props}
        />
      );

    return <AvisEditableListTableRow rowClass={rowClass} {...this.props} />;
  }

  public shouldComponentUpdate(
    nextProps: Readonly<IAvisEditableListRowClassProps<P>>,
  ): boolean {
    const valueUpdated = this.props.value !== nextProps.value;
    const errorsUpdated = this.props.errors !== nextProps.errors;
    const disabledUpdated = this.props.disabled !== nextProps.disabled;
    const arrayLengthUpdated = this.props.arrayLength !== nextProps.arrayLength;
    const viewUpdated = this.props.view !== nextProps.view;
    const forceUpdateKeyUpdated =
      this.props.forceUpdateKey !== nextProps.forceUpdateKey;

    const shoudUpdateComponentValue =
      viewUpdated ||
      valueUpdated ||
      errorsUpdated ||
      disabledUpdated ||
      arrayLengthUpdated ||
      forceUpdateKeyUpdated;

    return shoudUpdateComponentValue;
  }
}
